import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import TableauEnfant from '../components/TableauEnfant'
import ReglesEcole, { useReglesEcole } from '../components/ReglesEcole'

export default function PageEcole() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [pseudonyme, setPseudonyme] = useState('')
  const [autorise, setAutorise] = useState(false)
  const [showRegles, fermerRegles] = useReglesEcole()
  const [showReglesManuel, setShowReglesManuel] = useState(false)

  useEffect(() => {
    const enfantId = sessionStorage.getItem('ecole_enfant_id')
    const pseudo = sessionStorage.getItem('ecole_pseudonyme')
    if (enfantId !== id) { navigate('/acces-ecole'); return }
    setPseudonyme(pseudo || '')
    setAutorise(true)
  }, [id])

  if (!autorise) return null

  const afficherPopup = showRegles || showReglesManuel
  const fermerPopup = () => { fermerRegles(); setShowReglesManuel(false) }

  return (
    <div style={{ minHeight:'100vh', background:'#f8fafc', fontFamily:"'Inter',sans-serif" }}>
      {/* Popup règles */}
      {afficherPopup && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 }}>
          <ReglesEcole onFermer={fermerPopup} />
        </div>
      )}

      <header style={{ background:'#fff', borderBottom:'1px solid #e2e8f0', padding:'0 24px', height:52 }}>
        <div style={{ maxWidth:780, margin:'0 auto', height:'100%', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <button onClick={() => { sessionStorage.clear(); navigate('/acces-ecole') }} style={{ display:'flex', alignItems:'center', gap:6, padding:'5px 10px', borderRadius:6, border:'1px solid #e2e8f0', background:'#fff', color:'#64748b', fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
              Déconnexion
            </button>
            <div style={{ width:1, height:20, background:'#e2e8f0' }} />
            <div style={{ width:30, height:30, borderRadius:'50%', background:'#f0fdf4', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:14, color:'#16a34a' }}>
                {pseudonyme.charAt(0).toUpperCase()}
              </span>
            </div>
            <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:16, color:'#1e293b' }}>{pseudonyme}</span>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <button onClick={() => setShowReglesManuel(true)} style={{ padding:'4px 10px', borderRadius:6, border:'1px solid #e2e8f0', background:'#fff', color:'#64748b', fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
              Guide
            </button>
            <span style={{ fontSize:11, color:'#16a34a', background:'#f0fdf4', padding:'3px 10px', borderRadius:20, border:'1px solid #bbf7d0' }}>Vue école</span>
          </div>
        </div>
      </header>
      <div style={{ maxWidth:780, margin:'0 auto' }}>
        <TableauEnfant enfantId={id} estEcole={true} pseudonyme={pseudonyme} />
      </div>
    </div>
  )
}
